class Utils {
  static queryToObject(query) {
    return Object.fromEntries(new URLSearchParams(query));
  }

  static objectToQuery(obj) {
    return Object.entries(obj).map((p) => {
      return `${encodeURIComponent(p[0])}=${encodeURIComponent(p[1])}`;
    }).join('&');
  }

  static getHashbangValue(hashValue) {
    if (!hashValue) {
      return '';
    }

    const hashBangIndex = hashValue.indexOf('#!/');
    if (hashBangIndex === -1) {
      return '';
    }

    return hashValue.slice(hashBangIndex + 3);
  }

  static copyElementAttributes(source, destination, attributes = ['id', 'name', 'className', 'dataset', 'value']) {
    for (let i = 0; i < attributes.length; i++) {
      const attribute = attributes[i];
      if (!!source[attribute] && source[attribute].length === 0) {
        continue;
      }

      if (typeof (source[attribute]) === 'object') {
        Object.assign(destination[attribute], source[attribute]);
      } else {
        destination[attribute] = source[attribute];
      }
    }
  }

  static httpRequest(method, url, query, cb) {
    let fullUrl = url;
    if (typeof (query) === 'object' &&
        Object.keys(query).length > 0) {
      fullUrl += '?' + this.objectToQuery(query);
    }

    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open('GET', fullUrl, true);
    xmlHttpRequest.onreadystatechange = function() {
      if (xmlHttpRequest.readyState === 4) {
        const data = JSON.parse(xmlHttpRequest.responseText);
        cb(null, data);
      }
    };

    xmlHttpRequest.send();
  }
}

export default Utils;
